import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight, Plus, Check } from "lucide-react";
import { resolveImg } from "../lib/api";
import { useCart } from "../lib/cart";

export const ProductCard = ({ p, index = 0 }) => {
  const img = p.images && p.images.length ? resolveImg(p.images[0]) : null;
  const { items, add } = useCart();
  const inCart = items.some((i) => i.sku === p.sku);
  return (
    <motion.div
      initial={{ opacity: 0, y: 24 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-40px" }}
      transition={{ duration: 0.5, ease: [0.22, 1, 0.36, 1], delay: (index % 4) * 0.05 }}
    >
      <Link
        to={`/product/${p.slug}`}
        data-testid={`product-card-${p.sku}`}
        className="group flex flex-col h-full rounded-2xl border border-vr-border bg-white overflow-hidden hover:border-vr-brand hover:shadow-xl transition-all duration-300"
      >
        <div className="relative aspect-square bg-[#e6f4fc] flex items-center justify-center p-6 overflow-hidden">
          {img ? (
            <img src={img} alt={p.name} loading="lazy" className="max-h-full max-w-full object-contain transition-transform duration-500 group-hover:scale-105" />
          ) : (
            <div className="w-full h-full rounded-xl bg-vr-bg2" />
          )}
          {p.bestseller && (
            <span className="absolute top-3 left-3 text-[10px] font-bold uppercase tracking-wider bg-vr-brand text-white px-2.5 py-1 rounded-full">Best Seller</span>
          )}
        </div>
        <div className="flex flex-col flex-1 p-5 border-t border-vr-border">
          <div className="text-[11px] font-mono text-vr-brand tracking-wide">{p.sku}</div>
          <h3 className="mt-1 font-display font-bold text-vr-ink leading-snug line-clamp-2">{p.name}</h3>
          <div className="mt-2 flex flex-wrap gap-1.5">
            {p.outer_packing && <span className="text-[11px] text-vr-dim bg-vr-bg2 rounded px-2 py-0.5">{p.outer_packing}</span>}
            {p.unit_measure && <span className="text-[11px] text-vr-dim bg-vr-bg2 rounded px-2 py-0.5">{p.unit_measure}</span>}
          </div>
          <div className="mt-4 pt-4 border-t border-vr-border flex items-center justify-between gap-2">
            <span className="text-sm font-semibold text-vr-navy group-hover:text-vr-brand transition-colors inline-flex items-center gap-1">
              View
              <ArrowRight size={15} className="group-hover:translate-x-1 transition-transform" />
            </span>
            <button
              type="button"
              data-testid={`add-to-quote-${p.sku}`}
              onClick={(e) => { e.preventDefault(); e.stopPropagation(); add(p); }}
              className={`inline-flex items-center gap-1 text-xs font-semibold px-3 py-1.5 rounded-full transition-colors ${inCart ? "bg-vr-brand/10 text-vr-brand" : "bg-vr-navy text-white hover:bg-vr-brand"}`}
            >
              {inCart ? (<><Check size={13} /> In quote</>) : (<><Plus size={13} /> Add to Quote</>)}
            </button>
          </div>
        </div>
      </Link>
    </motion.div>
  );
};
